/* This file was generated automatically. Do not edit manually. */

import * as Types from '../types';
import { RestApiOptions } from './types';

export const createReservationGroupsRepository = (options: RestApiOptions): Types.ReservationGroupsRepository => ({
    async create(params, requestOptions) {
        return options.request('/reservationGroups/create', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async get(params, requestOptions) {
        return options.request('/reservationGroups/get', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
    async getAll(params, requestOptions) {
        return options.request('/reservationGroups/getAll', params, {
            method: 'post',
            responseType: 'json',
            ...requestOptions,
        });
    },
});
